module.exports = __webpack_public_path__ + "static/img/logo_sokker_branco.6952571.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo_sokker_branco.png
// module id = ID84
// module chunks = 2